"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
//import { rgba } from "../utils/color";

//base colors
//https://p.widencdn.net/rvivwz/Clayton_Brand_Book_2018

//primary
var primaryClaytonBlue = "#0075c9";
var primaryClaytonGreen = "#97d700";

//secondary
var secondaryRubberDucky = "#ffc50a";
var secondaryCheesePuff = "#f68c2c";
var secondaryLadyBug = "#ef4b5d";
var secondaryBarnDoor = "#b21F28";
var secondaryDusk = "#8D83BE";
var secondarySummerNight = "#352269";
var secondaryHoseWater = "#97D4CA";
var secondaryKiddiePool = "#00b0ac";
var secondaryFreshGrass = "#4F9E44";
var secondaryBigSky = "#00a0dd";
var secondaryWetCement = "#51748B";
var secondaryBedtime = "#06292F";

//grayscale
var grayscaleCoolGray01 = "#E6E6E6";
var grayscaleCoolGray03 = "#BCBEC0";
var grayscaleCoolGray06 = "#939598";
var grayscaleCoolGray08 = "#6D6E71";
var grayscaleCoolGray11 = "#414042";
var grayscaleBlack = "#231F20";

//neutrals
var neutralsWallTone = "#FCFAF5";
var neutralsBedroom = "#FFFAF0";
var neutralsBathroom = "#FFF9F4";
var neutralsKitchen = "#FFF4DF";
var neutralsInsulation = "#FFF0E4";
var neutralsNursery = "#F2F8FC";

//"web safe" colors per made, in the year 2018
var wsGrayscale01 = "#F8F8F8";
var wsGrayscale02 = "#EDEDED";
var wsGrayscale03 = "#9B9B9B";
var wsGrayscale04 = "#383838";
var wsGrayscale05 = "#1F1F1F";
var wsGrayscale06 = "#000000";

var wsWhite = "#FCFAF5";
var wsYellow = "#F9A825";
var wsPink = "#FF7879";
var wsGreen = "#52B349";
var wsBlue = "#008ACB";

//gradient pairs
var gradientYellowA = "#FFD529";
var gradientYellowB = "#FFA202";

var gradientOrangeLightA = "#FEA223";
var gradientOrangeLightB = "#F06F02";

var gradientRedA = "#FF661B";
var gradientRedB = "#FF4200";

var gradientOrangeDarkA = "#FF7879";
var gradientOrangeDarkB = "#FF4200";

var gradientBlueDarkA = "#364E61";
var gradientBlueDarkB = "#173340";

var gradientBlueMidA = "#5B6E88";
var gradientBlueMidB = "#3E556A";

var gradientBlueBrightA = "#5E76FE";
var gradientBlueBrightB = "#0026FF";

var gradientTealA = "#00FFEE";
var gradientTealB = "#2098D4";

var gradientTealLightA = "#00FFEE";
var gradientTealLightB = "#02BDC5";

var gradientGreenA = "#5BCA50";
var gradientGreenB = "#4EA646";

//stuff that the design used that wasn't in the main style guide
var miscDarkBlue = "#003f8c";
var miscLightGrey = "#f5f5f5";
var miscMediumGrey = "#d6d7d9";
var miscBluishGrey = "#b9c1cc";
var miscVeryLightBlue = "#dfedff";
var miscCheesepuffHover = "#da5300";
var miscClaytonGreenHover = "#57aa02";

//modified colors
//const modalOverlay = rgba(grayscaleCoolGray11, 0.5);

//Feature SVG colors
var featureAccent = "#b7e0f9";

exports.default = {
    primaryClaytonBlue: primaryClaytonBlue,
    primaryClaytonGreen: primaryClaytonGreen,

    secondaryRubberDucky: secondaryRubberDucky,
    secondaryCheesePuff: secondaryCheesePuff,
    secondaryLadyBug: secondaryLadyBug,
    secondaryBarnDoor: secondaryBarnDoor,
    secondaryDusk: secondaryDusk,
    secondarySummerNight: secondarySummerNight,
    secondaryHoseWater: secondaryHoseWater,
    secondaryKiddiePool: secondaryKiddiePool,
    secondaryFreshGrass: secondaryFreshGrass,
    secondaryBigSky: secondaryBigSky,
    secondaryWetCement: secondaryWetCement,
    secondaryBedtime: secondaryBedtime,

    grayscaleCoolGray01: grayscaleCoolGray01,
    grayscaleCoolGray03: grayscaleCoolGray03,
    grayscaleCoolGray06: grayscaleCoolGray06,
    grayscaleCoolGray08: grayscaleCoolGray08,
    grayscaleCoolGray11: grayscaleCoolGray11,
    grayscaleBlack: grayscaleBlack,

    neutralsWallTone: neutralsWallTone,
    neutralsBedroom: neutralsBedroom,
    neutralsBathroom: neutralsBathroom,
    neutralsKitchen: neutralsKitchen,
    neutralsInsulation: neutralsInsulation,
    neutralsNursery: neutralsNursery,

    wsGrayscale01: wsGrayscale01,
    wsGrayscale02: wsGrayscale02,
    wsGrayscale03: wsGrayscale03,
    wsGrayscale04: wsGrayscale04,
    wsGrayscale05: wsGrayscale05,
    wsGrayscale06: wsGrayscale06,
    wsWhite: wsWhite,
    wsYellow: wsYellow,
    wsPink: wsPink,
    wsGreen: wsGreen,
    wsBlue: wsBlue,

    gradientYellowA: gradientYellowA,
    gradientYellowB: gradientYellowB,
    gradientOrangeLightA: gradientOrangeLightA,
    gradientOrangeLightB: gradientOrangeLightB,
    gradientRedA: gradientRedA,
    gradientRedB: gradientRedB,
    gradientOrangeDarkA: gradientOrangeDarkA,
    gradientOrangeDarkB: gradientOrangeDarkB,
    gradientBlueDarkA: gradientBlueDarkA,
    gradientBlueDarkB: gradientBlueDarkB,
    gradientBlueMidA: gradientBlueMidA,
    gradientBlueMidB: gradientBlueMidB,
    gradientBlueBrightA: gradientBlueBrightA,
    gradientBlueBrightB: gradientBlueBrightB,
    gradientTealA: gradientTealA,
    gradientTealB: gradientTealB,
    gradientTealLightA: gradientTealLightA,
    gradientTealLightB: gradientTealLightB,
    gradientGreenA: gradientGreenA,
    gradientGreenB: gradientGreenB,

    miscDarkBlue: miscDarkBlue,
    miscLightGrey: miscLightGrey,
    miscMediumGrey: miscMediumGrey,
    miscBluishGrey: miscBluishGrey,
    miscVeryLightBlue: miscVeryLightBlue,
    miscCheesepuffHover: miscCheesepuffHover,
    miscClaytonGreenHover: miscClaytonGreenHover,
    //modalOverlay,
    featureAccent: featureAccent
};


//////////////////
// WEBPACK FOOTER
// ./~/pubweb-react-components/dist/styles/colors.js
// module id = 4
// module chunks = 168707334958949